// src/store/folderStore.js

import { create } from 'zustand';
import DataHelper from '../helpers/DataHelper';
import { select } from 'async';
import { checkIsAPINew} from '../Config';
// You might also need to pass props related to Redux actions (like requestServerPost)

const useFolderFileStore = create((set, get) => ({
    folderFileDatas: [],
    selectedFolderID: null,

    setFolderFileDatas: (newFolders) => set({ folderFileDatas: newFolders }),
    setSelectedFolderID: (setSelectedFolderID) => set({ selectedFolderID: setSelectedFolderID }),

    /**
     * Global action to fetch and update folder data.
     * @param {object} selectedBrandData - The current selected brand data.
     * @param {object} props - The Redux props needed for DataHelper (e.g., requestServerPost).
     */
    fetchFolderFileDatas: async (selectedBrandData, props) => {

        if(!checkIsAPINew())
        {
            get().setFolderFileDatas([]);
            return; 
        }

        if (!selectedBrandData) {
            console.log("no brand data");
            get().setFolderFileDatas([]); // Use the getter to call the setter
            return;
        }

        const params = { brandid: selectedBrandData.BrandID };

        try {
            const data = await DataHelper.getFolderFiles(params, props);
            if ("status" in data) {
                if (data.status === "success") {
                    get().setFolderFileDatas(data.data || []); // Use the getter to call the setter
                }
            } else {
                // Handle cases where data might be the array directly
                get().setFolderFileDatas(data || []);
            }
        } catch (err) {
            console.error("Error fetching folders:", err);
            // Optionally, handle error state here
        }
    },

    selectParentFolder: () => {
        const { folderFileDatas, selectedFolderID } = get();
        const selectedFolder = folderFileDatas.find(folder => folder.FolderID === selectedFolderID);
        if (selectedFolder && selectedFolder.FolderParentID) {
            get().setSelectedFolderID(selectedFolder.FolderParentID);
        } else {
            // If no parent, maybe set to null or root
            get().setSelectedFolderID(null);
        }
    },

    setParentFolderForTargetFile: async (targetFileID, parentFolderID, successCallback = () => { }, errorCallBack = () => { }, props) => {
        const { folderFileDatas, selectedFolderID } = get();
        try {
            const data = await DataHelper.updateFile({

                fileid: targetFileID,
                folderparentid: parentFolderID
            }, props);

            if ("status" in data) {
                if (data.status === "success") {
                    successCallback();
                }
            } else {
                errorCallBack();
            }
        } catch (err) {
            console.error("Error updating file parent:", err);
            errorCallBack();
        }
    },

    setParentFolderForTarget: async (targetFolderID, parentFolderID, successCallback = () => { }, errorCallBack = () => { }, props) => {
        const { folderFileDatas, selectedFolderID } = get();
        try {
            const data = await DataHelper.updateFolderFile({

                folderid: targetFolderID,
                folderparentid: parentFolderID
            }, props);

            if ("status" in data) {
                if (data.status === "success") {
                    successCallback();
                }
            } else {
                errorCallBack();
            }
        } catch (err) {
            console.error("Error updating folder parent:", err);
            errorCallBack();
        }
    },
    
}));

export default useFolderFileStore;